//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Signature from './_signature/main'
import get_consultant_medal from '@/common/mixins/get_consultant_medal'
import ConsultantMedal from '@/components/business/consultant_medal'

export default {
    mixins: [
        get_consultant_medal
    ],
    components :{
        Signature,
        ConsultantMedal,
    },
    props: {
        consultant: Object,
        is_consultant: Boolean,
        force_phone_auth: Boolean
    },
    methods: {
        openViewer (id) {
            wx.navigateTo({
                url: `/consultants/headimgs/main?id=${id}`
            })
        },
        goChat (e) {
            this.$emit('goChat', e)
        },
        setClipboardData (e) {
            wx.copyByDomId('weixin-number', 'weixin')
        },
        previewImg () {
            const img = this.consultant.original_headimgurl
            const current = img ? img.replace(/132$/, 0).replace(/\?x\-oss\-process=image\/resize,w_\w*,h_\w*(\/format,(webp|jpg))?/, '') : ''
            wx.previewImage({
                current,
                urls: [current]
            })
        },
        openMedal () {
            if (this.consultant.is_my_card) {
                wx.navigateTo({
                    url: `/personal_package/medal/main`
                })
            } else {
                this.showConsultantMedal(this.consultant.id)
            }
        }
    }
}
